// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var ToggleMandatory$ReactHooksTemplate = require("./ToggleMandatory.res.js");
var OpinionScaleLabel$ReactHooksTemplate = require("./OpinionScaleLabel.res.js");

function OpinionScaleEditor(props) {
  var onOpinionScaleChange = props.onOpinionScaleChange;
  var opinionScale = props.opinionScale;
  var leftCount = OpinionScaleLabel$ReactHooksTemplate.left(OpinionScale$ReactHooksTemplate.label(opinionScale)).length;
  var rightCount = OpinionScaleLabel$ReactHooksTemplate.right(OpinionScale$ReactHooksTemplate.label(opinionScale)).length;
  var onLabelChange = function (f, $$event) {
    var formTargetValue = Utils$ReactHooksTemplate.formTargetValue($$event);
    if (Utils$ReactHooksTemplate.checkMaxLength24(formTargetValue)) {
      return Curry._1(onOpinionScaleChange, OpinionScale$ReactHooksTemplate.setLabel(opinionScale, Curry._2(f, OpinionScale$ReactHooksTemplate.label(opinionScale), formTargetValue)));
    }
    
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(ToggleMandatory$ReactHooksTemplate.make, {
                      mandatory: props.mandatory,
                      onMandatoryChange: props.onMandatoryChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                "Left Label",
                                JsxRuntime.jsx("p", {
                                      children: String(leftCount) + (" / " + String(24)),
                                      className: "text-gray-500 text-xs p-1 flex justify-end"
                                    })
                              ],
                              className: "text-darkcharcoal text-sm mb-2 font-medium flex justify-between"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "h-40-px py-2 px-4 rounded bg-white border border-gray-300 focus:border-gray-600 text-xs w-full",
                              placeholder: "Enter Left Label",
                              type: "text",
                              value: OpinionScaleLabel$ReactHooksTemplate.left(OpinionScale$ReactHooksTemplate.label(opinionScale)),
                              onChange: (function (param) {
                                  return onLabelChange(OpinionScaleLabel$ReactHooksTemplate.setLeft, param);
                                })
                            })
                      ],
                      className: "mb-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                "Right Label",
                                JsxRuntime.jsx("p", {
                                      children: String(rightCount) + (" / " + String(24)),
                                      className: "text-gray-500 text-xs p-1 flex justify-end"
                                    })
                              ],
                              className: "text-darkcharcoal text-sm mb-2 font-medium flex justify-between"
                            }),
                        JsxRuntime.jsx("input", {
                              className: "h-40-px py-2 px-4 rounded bg-white border border-gray-300 focus:border-gray-600 text-xs w-full",
                              placeholder: "Enter Right Label",
                              type: "text",
                              value: OpinionScaleLabel$ReactHooksTemplate.right(OpinionScale$ReactHooksTemplate.label(opinionScale)),
                              onChange: (function (param) {
                                  return onLabelChange(OpinionScaleLabel$ReactHooksTemplate.setRight, param);
                                })
                            })
                      ],
                      className: "mb-4"
                    })
              ]
            });
}

var maxCount = 24;

var make = OpinionScaleEditor;

exports.maxCount = maxCount;
exports.make = make;
/* react/jsx-runtime Not a pure module */
